module.exports = __webpack_public_path__ + "static/media/strikethrough-comments.3a0a4445.svg";